const actions = {
  async getData({ dispatch }, { params, query, selectedSearch }) {
    const updateView = () => {
      const { baseReportName, routeName } = params
      const endpointKey = baseReportName || routeName
      return dispatch('tools/updateView', { endpointKey }, { root: true })
    }
    const setView = () => {
      const { reportPath } = query
      const haveSelectedSearch = !!(reportPath && selectedSearch)
      return haveSelectedSearch && dispatch('tools/setView', { params, query }, { root: true })
    }

    return setView() || updateView()
  },
}

export default actions
